import React, { Component } from "react";
import "./AboutUsStyles.css";

class AboutUsData extends Component {
  render() {
    return (
      <div className="bio-layout">
        <div className="bio-text">
          <p>{this.props.text}</p>
          <p>{this.props.text2}</p>
          <p>{this.props.text3}</p>
        </div>
        <div className="bio-image-wrap">
          <img className="bio-image" src={this.props.img} alt="Susan Heidenreich" />
        </div>
      </div>
    );
  }
}

export default AboutUsData;
